/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/auth/user.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Grant {
    /**
     * @param {?} data
     */
    constructor(data) {
        this.permission = data.permission;
        this.resource = data.resource;
        this.status = data.status;
    }
    /**
     * @param {?} permission
     * @param {?} resource
     * @return {?}
     */
    matches(permission, resource) {
        if (this.resource === "*" && this.permission == permission) {
            return true;
        }
        return false;
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    Grant.prototype.permission;
    /**
     * @type {?}
     * @private
     */
    Grant.prototype.resource;
    /**
     * @type {?}
     * @private
     */
    Grant.prototype.status;
}
/**
 * A wrapper for features that loads the value from the document body.
 */
export class User {
    /**
     * @param {?} user
     */
    constructor(user) {
        this.id = user.id;
        this.email = user.email;
        this.grants = user.grant.map((/**
         * @param {?} g
         * @return {?}
         */
        g => new Grant(g)));
    }
    /**
     * @return {?}
     */
    static empty() {
        return new User({
            id: "0",
            email: "user@example.com",
            // TODO: Make this be all the permissions.
            grant: [],
        });
    }
    /**
     * @return {?}
     */
    static fromBody() {
        /** @type {?} */
        const user = JSON.parse(document.body.dataset.user);
        return new User(user);
    }
    /**
     * @param {?} permission
     * @param {?} resource
     * @return {?}
     */
    hasPermission(permission, resource) {
        return this.grants.some((/**
         * @param {?} g
         * @return {?}
         */
        g => g.matches(permission, resource)));
    }
    /**
     * @return {?}
     */
    isAuthenticated() { return this.id !== "0"; }
}
if (false) {
    /** @type {?} */
    User.prototype.id;
    /** @type {?} */
    User.prototype.email;
    /**
     * @type {?}
     * @private
     */
    User.prototype.grants;
}
//# sourceMappingURL=data:application/json;base64,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